export default __webpack_public_path__ + "static/media/AAA.fdd9fe6c.svg";